import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
import {TIE, UNTIE} from '../../../constants/MicroServiceConstants';

const initialData = {
  updateAccountStatus: null,
  updateAccountUntieAgencyStatus: null,
  updateAccountUntieRouteStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'accountTie',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    updateAccountTieInfo: (state, action) => {
      state.updateAccountStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response ? action.payload.response : null;
    },
    updateAccountUnTieAgencyInfo: (state, action) => {
      state.updateAccountUntieAgencyStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response ? action.payload.response : null;
    },
    updateAccountUntieRouteInfo: (state, action) => {
      state.updateAccountUntieRouteStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response ? action.payload.response : null;
    },

    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.updateAccountStatus = null;
      state.updateAccountUntieAgencyStatus = null;
      state.updateAccountUntieRouteStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  updateAccountTieInfo,
  updateAccountUnTieAgencyInfo,
  updateAccountUntieRouteInfo,
  fetchStart,
  fetchError,
  resetMsg,
} = slice.actions;

export const updateAccountTie = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${TIE}/account/${TIE}`, data)
      .then((data) => {
        if (data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.error ? data?.data?.error : data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(updateAccountTieInfo(data));
        } else {
          dispatch(fetchError(data?.data?.error ? data?.data?.error : data?.data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const updateRouteTie = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${TIE}/account/route/${TIE}`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(updateAccountTieInfo(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const updateAccountAgencyUnTie = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${TIE}/account/agency/untie`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(updateAccountUnTieAgencyInfo(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const updateAccountRouteUnTie = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${TIE}/account/route/${UNTIE}`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(updateAccountUntieRouteInfo(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
